export const pickTextColorBasedOnBgColorSimple = (
  bgColor = '#ffffff',
  lightColor: string,
  darkColor: string
) => {
  const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
  const red = parseInt(color.substring(0, 2), 16);
  const green = parseInt(color.substring(2, 4), 16);
  const blue = parseInt(color.substring(4, 6), 16);

  return red * 0.299 + green * 0.587 + blue * 0.114 > 186
    ? darkColor
    : lightColor;
};
